import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { SearchBox as TeaSearchBox } from 'tea-component';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { ISearchBoxProps } from './type';
import { buildPatchDataChange, getInitialSearchValue, parsePath } from './utils';
import './index.scss';

export const SearchBox: React.FC<ISearchBoxProps> = ({
  className,
  placeholderEn = 'Search games',
  placeholderCn = '搜索游戏',
  patchData,
  data,
  changeData,
}) => {
  const { isEN } = useLocal();
  const placeholder = isEN ? placeholderEn : placeholderCn;

  const patchSegments = useMemo(() => (
    patchData ? parsePath(patchData.keys) : []
  ), [patchData]);

  const [inputValue, setInputValue] = useState<string>(() => {
    if (!patchData || !data) return '';
    return getInitialSearchValue(data, patchSegments);
  });

  const handleSearch = (value?: string) => {
    if (!patchData || !data) return;
    const { key, value: newValue } = buildPatchDataChange(data, value || '', patchSegments);
    changeData?.(key, newValue);
    window.requestAnimationFrame(() => {
      const { activeElement } = document;
      if (activeElement instanceof HTMLInputElement) {
        activeElement.blur();
      }
    });
  };

  const handleClear = () => {
    setInputValue('');
    if (!patchData || !data) return;
    const { key, value } = buildPatchDataChange(data, '', patchSegments);
    changeData?.(key, value);
  };

  return (
    <div className={classNames('dbd-plugin-search-box', className)}>
      <TeaSearchBox
        className="dbd-plugin-search-box__input"
        value={inputValue}
        placeholder={placeholder}
        onChange={(value) => setInputValue(value)}
        onSearch={handleSearch}
        onClear={handleClear}
      />
    </div>
  );
};

export default SearchBox;
